import db from './db';

const LAST_SAVED_KEY = 'last-saved-at';

type Callback = () => void;
const callbacks: Callback[] = [];

export async function getLastSavedAt(): Promise<string | null> {
  const value = await db.getItem<string>(LAST_SAVED_KEY);
  return value ?? null;
}

export async function bumpLastSavedAt(): Promise<void> {
  await db.setItem(LAST_SAVED_KEY, new Date().toISOString());
  callbacks.forEach((cb) => cb());
}

export function subscribeLastSavedAt(cb: Callback): () => void {
  callbacks.push(cb);
  return () => {
    const idx = callbacks.indexOf(cb);
    if (idx >= 0) callbacks.splice(idx, 1);
  };
}
